import { NgxsModule } from '@ngxs/store';
import { NotificationsFacade } from './state/notifications.facade';
import { NotificationsState } from './state/notifications.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export let NotificationsFrontendSharedModule = /*#__PURE__*/(() => {
  class NotificationsFrontendSharedModule {
    static {
      this.ɵfac = function NotificationsFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: NotificationsFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [NotificationsFacade],
        imports: [NgxsModule.forFeature([NotificationsState])]
      });
    }
  }
  return NotificationsFrontendSharedModule;
})();